// extracted by mini-css-extract-plugin
export var buttonContainer = "_8x-1";
export var fontSizeSelect = "_8x-3";
export var formatSelect = "_8x-2";
export var formats = "_8x-4";
export var hidden = "_8x-5";
export var icon = "_8x-6";
export var select = "_8x-0";